import {subdebug} from '@sanity/cli-core'

export const backupDownloadDebug = subdebug('backup:download')
